export default "<app-mat-tree type=\"interest\" listName=\"interests\"></app-mat-tree>\n<router-outlet></router-outlet>";